import React, { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

const ForkliftTabsComponent = () => {
    const [activeTab, setActiveTab] = useState('diesel');
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 640);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const dieselFeatures = [
        {
            title: "Strong And Durable Chasis",
            description: "Using the IC truck structures, which has been <strong>tested</strong> by the market for <strong>more than 20 years</strong>. <strong>Built tough</strong> to handle the most demanding operations.",
            image: "/images/forklifts/diesel_forklift_1.webp"
        },
        {
            title: "Safety & Reliability",
            description: "Trusted worldwide for strict safety standards and consistent, long-lasting performance.",
            image: "/images/forklifts/diesel_forklift_2.webp"
        },
        {
            title: "Worldwide Trusted Design",
            description: "Backed by global expertise and advanced engineering to ensure efficiency and comfortability in every environment.",
            image: "/images/forklifts/diesel_forklift_3.webp"
        }
    ];

    const electricFeatures = [
        {
            title: "Multi-Scenario Usage",
            description: "Adopting the IC forklift structures enable to operate indoor and outdoor, with great waterproof and dustproof performance.",
            image: "/images/forklifts/electric_forklift_1.webp"
        },
        {
            title: "Safety & Reliability",
            description: "The special hydraulic station ensures the steering is working when you are applying the brake. CAN-bus and BMS system monitor and protect the truck all the time. The big open angle allows you to reach all the parts easily.",
            image: "/images/forklifts/electric_forklift_2.webp"
        },
        {
            title: "Fast Charging",
            description: "With two charging sockets, a fully charge only needs about 2-2.5 hours, and can be charged to 80% in 1.5 hours, it also can be charged at any time during the day to ensure multiple shifts.",
            image: "/images/forklifts/electric_forklift_3.webp"
        }
    ];

    const currentFeatures = activeTab === 'diesel' ? dieselFeatures : electricFeatures;

    const renderMobileView = () => (
        <div className="mobile-swiper-container">
            <Swiper
                modules={[Pagination, Navigation, Autoplay]}
                spaceBetween={16}
                slidesPerView={1.1}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                pagination={false}
                navigation={false}
                className="forklift-swiper"
            >
                {currentFeatures.map((feature, index) => (
                    <SwiperSlide key={index}>
                        <div className="mobile-slide">
                            <div className="mobile-feature-image">
                                <img src={feature.image} alt={feature.title} />
                            </div>
                            <div className="mobile-feature-content">
                                <h2>{feature.title}</h2>
                                <p dangerouslySetInnerHTML={{ __html: feature.description }} />
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );

    const renderDesktopView = () => (
        <>
            {currentFeatures.map((feature, index) => (
                <div key={index} className="feature-section">
                    <div className="feature-image">
                        <img src={feature.image} alt={feature.title} />
                    </div>
                    <div className="feature-content">
                        <h2>{feature.title}</h2>
                        <p dangerouslySetInnerHTML={{ __html: feature.description }} />
                    </div>
                </div>
            ))}
        </>
    );

    return (
        <>
            {/* CHANGED: Removed my-14, kept only py-12 for section spacing */}
            <section className={`py-8 sm:py-16 forklift-tabs-section ${activeTab === 'diesel' ? 'diesel-bg' : 'electric-bg'}`}>
                <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
                    {/* Tab Header */}
                    <div className="tab-header">
                        <button
                            className={`tab-button diesel ${activeTab === 'diesel' ? 'active' : ''}`}
                            onClick={() => setActiveTab('diesel')}
                        >
                            Diesel Forklift
                        </button>
                        <button
                            className={`tab-button electric ${activeTab === 'electric' ? 'active' : ''}`}
                            onClick={() => setActiveTab('electric')}
                        >
                            Electric Forklift
                        </button>
                    </div>

                    {/* Content */}
                    <div className="tab-content active">
                        <div className="intro-text">
                            Powerful. Reliable. Built for heavy-duty performance. UN Diesel Forklifts deliver unmatched strength and durability. <strong>Trusted worldwide for over 45 years</strong>, they excel in <strong>construction, logistics, & demanding operations.</strong>
                        </div>

                        {isMobile ? renderMobileView() : renderDesktopView()}
                    </div>
                </div>
            </section>

            <style jsx>{`
                /* Section Background */
                .forklift-tabs-section {
                    transition: background 0.4s ease-in;
                }

                .forklift-tabs-section.diesel-bg {
                    background: linear-gradient(159.21deg, rgba(255, 210, 0, 0.15) 11.19%, rgba(247, 151, 30, 0.15) 101.23%);
                }

                .forklift-tabs-section.electric-bg {
                    background: rgba(6, 254, 3, 0.15);
                }

                /* Tab Header */
                .tab-header {
                    display: flex;
                    //border-bottom: 3px solid #8B4513;
                    margin-bottom: 0;
                }

                .tab-button {
                    flex: 1;
                    padding: 20px 40px;
                    font-size: 32px;
                    font-weight: 600;
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    position: relative;
                }

                .tab-button.diesel {
                    color: #999;
                }
                
                .tab-button.electric {
                    color: #999;
                }
                
                .tab-button.active.diesel {
                    color: rgba(158, 63, 46, 1);
                }

                .tab-button.active.electric {
                    color: rgba(0, 124, 145, 1);
                }

                .tab-button.active::after {
                    content: '';
                    position: absolute;
                    bottom: -3px;
                    left: 0;
                    width: 100%;
                    height: 3px;
                }

                .tab-button.active.diesel::after {
                    background-color: rgba(158, 63, 46, 1);
                }

                .tab-button.active.electric::after {
                    background-color: rgba(0, 124, 145, 1);
                }

                /* Tab Content - OPTIMIZED SPACING */
                .tab-content {
                    padding: 48px 0 0 0; /* Top padding only, removed sides and bottom */
                    animation: fadeIn 0.4s ease-in;
                }

                .tab-content.active {
                    display: block;
                }

                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                /* Content Introduction - OPTIMIZED */
                .intro-text {
                    margin-bottom: 48px; /* Consistent spacing */
                    font-size: 20px;
                    line-height: 1.5;
                }

                .intro-text strong {
                    font-weight: 700;
                }

                /* Desktop Feature Section - OPTIMIZED SPACING */
                .feature-section {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 48px; /* Consistent with intro text spacing */
                    margin-bottom: 48px; /* Consistent vertical rhythm */
                    align-items: center;
                }

                /* Remove extra margin from last feature */
                .feature-section:last-child {
                    margin-bottom: 0;
                }

                .feature-section:nth-child(odd) {
                    grid-template-columns: 1fr 1fr;
                }

                .feature-section:nth-child(odd) .feature-image {
                    order: 2;
                }

                .feature-section:nth-child(odd) .feature-content {
                    order: 1;
                }

                .feature-image {
                    width: 100%;
                    border-radius: 8px;
                    overflow: hidden;
                }

                .feature-image img {
                    width: 100%;
                    height: auto;
                    display: block;
                    object-fit: cover;
                }
                
                .feature-image:hover img {
                    transform: scale(1.05);
                    transition: transform 0.5s ease;
                }


                .feature-content h2 {
                    font-size: 36px;
                    font-weight: 700;
                    font-style: italic;
                    margin-bottom: 16px; /* Reduced from 20px */
                    color: #1a1a1a;
                }

                .feature-content p {
                    font-size: 20px;
                    line-height: 1.5;
                    color: #333;
                    margin: 0; /* Remove default paragraph margin */
                }

                /* Mobile Swiper Styles - OPTIMIZED */
                .mobile-swiper-container {
                    margin-top: 0; /* Removed, spacing handled by parent */
                }

                .mobile-slide {
                    padding-bottom: 50px; /* Space for pagination dots */
                }

                .mobile-feature-image {
                    width: 100%;
                    border-radius: 8px;
                    overflow: hidden;
                    margin-bottom: 24px; /* Spacing between image and content */
                }

                .mobile-feature-image img {
                    width: 100%;
                    height: auto;
                    display: block;
                    object-fit: cover;
                }

                .mobile-feature-content h2 {
                    font-size: 24px;
                    font-weight: 700;
                    font-style: italic;
                    margin-bottom: 12px; /* Proportional to desktop */
                    color: #1a1a1a;
                }

                .mobile-feature-content p {
                    font-size: 20px;
                    line-height: 1.5;
                    color: #000;
                    margin: 0;
                }

                /* Swiper customization */
                :global(.forklift-swiper) {
                    padding-bottom: 50px !important;
                }

                :global(.forklift-swiper .swiper-pagination) {
                    bottom: 10px !important;
                }

                :global(.forklift-swiper .swiper-button-next),
                :global(.forklift-swiper .swiper-button-prev) {
                    color: #8B4513;
                }

                /* Tablet Responsive - OPTIMIZED (768px - 968px) */
                @media (max-width: 968px) {
                    .tab-button {
                        font-size: 24px;
                        padding: 16px 32px; /* Slightly reduced */
                    }

                    .tab-content {
                        padding-top: 40px; /* Reduced proportionally */
                    }

                    .intro-text {
                        margin-bottom: 40px;
                        font-size: 20px;
                    }

                    .feature-section {
                        grid-template-columns: 1fr;
                        gap: 32px; /* Reduced gap */
                        margin-bottom: 40px;
                    }

                    .feature-section:nth-child(odd) .feature-image,
                    .feature-section:nth-child(odd) .feature-content {
                        order: unset;
                    }

                    .feature-content h2 {
                        font-size: 28px;
                        margin-bottom: 14px;
                    }
                }

                /* Mobile Responsive - OPTIMIZED (< 640px) */
                @media (max-width: 640px) {
                    .tab-button {
                        font-size: 22px;
                        padding: 9px; /* Optimized for mobile tap targets */
                    }

                    .tab-content {
                        padding-top: 32px; /* Reduced for mobile */
                    }

                    .intro-text {
                        font-size: 20px;
                        margin-bottom: 32px; /* Reduced for mobile */
                    }

                    /* Hide desktop grid on mobile */
                    .feature-section {
                        display: none;
                    }

                    .mobile-slide {
                        padding-bottom: 45px;
                    }

                    .mobile-feature-image {
                        margin-bottom: 20px;
                    }

                    .mobile-feature-content h2 {
                        font-size: 24px;
                        margin-bottom: 10px;
                    }
                }

                /* Extra Small Mobile - OPTIMIZED (< 375px) */
                @media (max-width: 375px) {
                    .tab-button {
                        font-size: 20px;
                        padding: 12px 16px;
                    }

                    .tab-content {
                        padding-top: 24px;
                    }

                    .intro-text {
                        margin-bottom: 24px;
                    }

                    .mobile-feature-content h2 {
                        font-size: 20px;
                    }
                }
            `}</style>
        </>
    );
}

export default ForkliftTabsComponent